import * as React from "react";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { useIssqn } from "../../../Storage/issqn";
import theme from "../../../Styles/theme";
import { useSeletor } from "../../../Storage/seletor";

export function CheckBox() {
  const { colunas, setColunas, setHelpColumn, helpColumn } = useIssqn();
  const [helpHide, setHelpHide] = React.useState(false);

  const {
    alterados,
    setAlterados,
    resumo,
    setResumo,
    pagos,
    pendentes,
    setPagos,
    setPendentes,
  } = useSeletor();
  async function help() {
    setColunas((prev) => prev);
    setHelpHide(true);
    await new Promise((r) => setTimeout(r, 1));
    setHelpHide(false);
  }

  React.useEffect(() => {
    help();
  }, [helpColumn]);

  function handleStatus(
    botao:
      | "PERIODO"
      | "STATUS"
      | "BASE"
      | "ISSQN"
      | "INFORMANTE"
      | "DATA_INFORMACAO"
      | "MOTIVO"
      | "VENCIMENTO"
      | "CODIGO"
      | "VALOR_CALCULADO"
      | "BASE_CALCULADA"
  ) {
    const teste = colunas;
    teste[botao] = !teste[botao];
    setColunas((prev) => teste);
    setHelpColumn(JSON.stringify(teste));
    // help();
  }

  React.useEffect(() => {
    setResumo(false);
    setAlterados(false);
  }, [window.location.href]);

  return (
    <FormControl component="fieldset">
      <FormLabel component="legend"></FormLabel>
      {helpHide ? (
        ""
      ) : (
        <div
          style={{
            display: "flex",
            width: "100vw",
            flexWrap: "nowrap",
            alignItems: "center",
            overflowX: "auto",
            margin: "auto",
          }}
        >
          <FormControlLabel
            style={{ marginRight: "2px", whiteSpace: "nowrap" }}
            value="ISSs alterados"
            control={
              <Checkbox
                checked={alterados}
                onClick={() => {
                  setAlterados(!alterados);
                }}
              />
            }
            label="ISSs alterados"
            labelPlacement="start"
          />
          <FormControlLabel
            style={{ marginRight: "2px", whiteSpace: "nowrap" }}
            value="Visualizar resumo"
            control={
              <Checkbox
                checked={resumo}
                onClick={() => {
                  setResumo(!resumo);
                }}
              />
            }
            label="Visualizar resumo"
            labelPlacement="start"
          />
          <FormControlLabel
            style={{ marginRight: "2px", whiteSpace: "nowrap" }}
            value="Pagos"
            control={
              <Checkbox
                checked={pagos}
                onClick={() => {
                  setPendentes(false);
                  setPagos((prev) => !prev);
                }}
              />
            }
            label="Filtrar Pagos"
            labelPlacement="start"
          />
          <FormControlLabel
            style={{ marginRight: "2px", whiteSpace: "nowrap" }}
            value="Pendentes"
            control={
              <Checkbox
                checked={pendentes}
                onClick={() => {
                  setPagos(false);
                  setPendentes(!pendentes);
                }}
              />
            }
            label="Filtrar Pendentes"
            labelPlacement="start"
          />
          {/* <div style={{  display: "flex",width: "90%" ,overflow:"auto", }}> */}
          <FormControlLabel
            style={{ marginRight: "2px", whiteSpace: "nowrap" }}
            value="Periodo"
            control={
              <Checkbox
                checked={colunas.PERIODO}
                onClick={() => {
                  handleStatus("PERIODO");
                }}
              />
            }
            label="Periodo"
            labelPlacement="start"
          />
          <FormControlLabel
            style={{ marginRight: "2px", whiteSpace: "nowrap" }}
            value="Status"
            control={
              <Checkbox
                checked={colunas.STATUS}
                onClick={() => {
                  handleStatus("STATUS");
                }}
              />
            }
            label="Status"
            labelPlacement="start"
          />
          <FormControlLabel
            style={{ marginRight: "2px", whiteSpace: "nowrap" }}
            value="Base"
            control={
              <Checkbox
                checked={colunas.BASE}
                onClick={() => {
                  handleStatus("BASE");
                }}
              />
            }
            label="Base"
            labelPlacement="start"
          />
          <FormControlLabel
            style={{ marginRight: "2px", whiteSpace: "nowrap" }}
            value="Base Calculada"
            control={
              <Checkbox
                checked={colunas.BASE_CALCULADA}
                onClick={() => {
                  handleStatus("BASE_CALCULADA");
                }}
              />
            }
            label="Base Calculada"
            labelPlacement="start"
          />
          <FormControlLabel
            style={{ marginRight: "2px", whiteSpace: "nowrap" }}
            value="Iss"
            control={
              <Checkbox
                checked={colunas.ISSQN}
                onClick={() => {
                  handleStatus("ISSQN");
                }}
              />
            }
            label="Iss Informado"
            labelPlacement="start"
          />
          <FormControlLabel
            style={{ marginRight: "2px", whiteSpace: "nowrap" }}
            value="Iss Calculado"
            control={
              <Checkbox
                checked={colunas.VALOR_CALCULADO}
                onClick={() => {
                  handleStatus("VALOR_CALCULADO");
                }}
              />
            }
            label="Iss Calculado"
            labelPlacement="start"
          />
          <FormControlLabel
            style={{ marginRight: "2px", whiteSpace: "nowrap" }}
            value="Informante"
            control={
              <Checkbox
                checked={colunas.INFORMANTE}
                onClick={() => {
                  handleStatus("INFORMANTE");
                }}
              />
            }
            label="Informante"
            labelPlacement="start"
          />
          <FormControlLabel
            style={{ marginRight: "2px", whiteSpace: "nowrap" }}
            value="Data Informação"
            control={
              <Checkbox
                checked={colunas.DATA_INFORMACAO}
                onClick={() => {
                  handleStatus("DATA_INFORMACAO");
                }}
              />
            }
            label="Data Informação"
            labelPlacement="start"
          />
          <FormControlLabel
            style={{ marginRight: "2px", whiteSpace: "nowrap" }}
            value="Data Vencimento"
            control={
              <Checkbox
                checked={colunas.VENCIMENTO}
                onClick={() => {
                  handleStatus("VENCIMENTO");
                }}
              />
            }
            label="Data Vencimento"
            labelPlacement="start"
          />
          <FormControlLabel
            style={{ marginRight: "2px", whiteSpace: "nowrap" }}
            value="Código de Barras"
            control={
              <Checkbox
                checked={colunas.CODIGO}
                onClick={() => {
                  handleStatus("CODIGO");
                }}
              />
            }
            label="Código de Barras"
            labelPlacement="start"
          />
          <FormControlLabel
            style={{ marginRight: "2px", whiteSpace: "nowrap" }}
            value="Motivo"
            control={
              <Checkbox
                checked={colunas.MOTIVO}
                onClick={() => {
                  handleStatus("MOTIVO");
                }}
              />
            }
            label="Motivo"
            labelPlacement="start"
          />{" "}
          {/* <h1>  {JSON.stringify(colunas)}</h1> */}
        </div>
      )}
    </FormControl>
  );
}
